import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ResponseService {

  show(options: any) {
    Swal.fire(options);
  }

  close() {
    Swal.close();
  }

  // showSuccess(options: any) {
  //   options.icon = 'success';
  //   this.show(options);
  // }

  showAddSuccess(message?: string) {
    const options: SweetAlertOptions = {
      title: 'Success!',
      text: message ? message : 'Data has been added successfully.',
      showCloseButton: true,
      iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/add-success-v2.svg" alt="tes">',
      customClass: {
        icon: 'no-border'
      },
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showAddError(message?: string) {
    const options: SweetAlertOptions = {
      title: 'Error',
      text: message ? message : 'An unexpected error occurred. Please check your connection and try again.',
      showCloseButton: true,
      iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/add-failed-v2.svg" alt="tes">',
      customClass: {
        icon: 'no-border'
      },
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showDeleteSuccess(message?: string) {
    const options: SweetAlertOptions = {
      title: 'Success',
      text: message ? message : 'Data has been deleted successfully.',
      showCloseButton: true,
      iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/delete-success.svg" alt="tes">',
      customClass: {
        icon: 'no-border'
      },
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showDeleteFailed(message?: string) {
    const options: SweetAlertOptions = {
      title: 'Error',
      text: message ? message : 'An unexpected error occurred. Please check your connection and try again.',
      showCloseButton: true,
      iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/delete-failed.svg" alt="tes">',
      customClass: {
        icon: 'no-border'
      },
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showEditSuccess(message?: string) {
    const options: SweetAlertOptions = {
      title: 'Success',
      text: message ? message : 'Data has been updated successfully.',
      showCloseButton: true,
      iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/edit-success.svg" alt="tes">',
      customClass: {
        icon: 'no-border'
      },
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showEditFailed(message?: string) {
    const options: SweetAlertOptions = {
      title: 'Error',
      text: message ? message : 'An unexpected error occurred. Please check your connection and try again.',
      showCloseButton: true,
      iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/edit-failed.svg" alt="tes">',
      customClass: {
        icon: 'no-border'
      },
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showWarning(message?: string, title?: string) {
    const options: SweetAlertOptions = {
      title: title ? title : 'Warning',
      text: message ? message : 'An unexpected warning occurred. Please check your connection and try again.',
      showCloseButton: true,
      icon: 'warning',
      confirmButtonText: 'OK',
    }
    this.show(options);
  }

  showConfirmation(message?: string, title?: string) {
    return Swal.fire({
      title: title ? title : 'Are you sure?',
      text: message ? message : 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    });
  }
}
